import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { PageContentService } from './page-content.service';
import { PageContentStore } from './page-content.store';
import { PageContentQuery } from './page-content.query';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppToken } from '../../../models/app-token';
import { Observable, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { PageContentModel } from './page-content.model';

@Injectable({ providedIn: 'root' })
export class PageContentFacade extends BaseFacade {

  constructor(
    private readonly pageContentService: PageContentService,
    pageContentStore: PageContentStore,
    pageContentQuery: PageContentQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(pageContentService,
      pageContentStore,
      pageContentQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(AppToken.PAGE_CONTENT_SCHEMA_NAME),
      translateService,
      AppToken.PAGE_CONTENT_SCHEMA_NAME + '-facade');
  }

  getPageContentsByPageId(id: string, orderBy: string = 'id', draftMode: boolean = false): Observable<PageContentModel[]> {
    return this.pageContentService.getByParentId(id, 'pageid', orderBy, draftMode).pipe(flatMap((contentList) => {
      return of(contentList.items) as Observable<PageContentModel[]>;
    }));
  }

  getPageContentsByContentId(id: string): Observable<PageContentModel[]> {
    return this.pageContentService.getByParentId(id, 'contentid').pipe(flatMap((contentList) => {
      return of(contentList.items) as Observable<PageContentModel[]>;
    }));
  }

}
